import { initSmoothScroll } from './modules/smooth-scroll';
import { initTocHighlight } from './modules/toc-highlight';
import { initFaqAccordion } from './modules/faq-accordion';
import { initNavToggle } from './modules/nav-toggle';
import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

initSmoothScroll();
initTocHighlight();
initFaqAccordion();
initNavToggle();

const heroSlide = document.querySelector('.home-hero__slide .swiper');
if (heroSlide) {
  new Swiper(heroSlide, {
    modules: [Autoplay, EffectFade],
    effect: 'fade',
    fadeEffect: { crossFade: true },
    loop: true,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
  });
}
